import { render, staticRenderFns } from "./2EmploymentData.vue?vue&type=template&id=212b1608&scoped=true"
import script from "./2EmploymentData.vue?vue&type=script&lang=js"
export * from "./2EmploymentData.vue?vue&type=script&lang=js"
import style0 from "./2EmploymentData.vue?vue&type=style&index=0&id=212b1608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212b1608",
  null
  
)

export default component.exports